import React from 'react';
import './benefitSection.scss'
import {ParallaxProvider, ParallaxBanner, ParallaxBannerLayer} from 'react-scroll-parallax';
import {StaticImage} from "gatsby-plugin-image";

function BenefitSection() {
  return (
    <ParallaxProvider>
      <ParallaxBanner
        style={{width: '100%'}}
        className='benefit-section'
      >
        <ParallaxBannerLayer speed={-25}>
          <StaticImage style={{width: '100%', height: '100%'}} src='../../../images/homepage/benefit/milos-isidora.webp' alt='parallax' />
        </ParallaxBannerLayer>
        <div className='benefit-section__wrapper'>
          <div className='benefit-section__wrapper__headline'>
            <h2>
              Trusted by thousands of companies around the world
            </h2>
          </div>
          <div className='benefit-section__wrapper__points'>
            <div className='benefit-section__wrapper__points__text'>
              <div className='benefit-section__wrapper__points__text__title'>
                50k+
              </div>
              <div className='benefit-section__wrapper__points__text__subtitle'>
                Businesses and individual entrepreneurs from a variety of industries use our booking software solutions.
              </div>
            </div>
            <div className='benefit-section__wrapper__points__text'>
              <div className='benefit-section__wrapper__points__text__title'>
                8m+
              </div>
              <div className='benefit-section__wrapper__points__text__subtitle'>
                Appointments and events worldwide have been processed with the help of our appointments booking software.
              </div>
            </div>
            <div className='benefit-section__wrapper__points__text'>
              <div className='benefit-section__wrapper__points__text__title'>
                $1.5m+
              </div>
              <div className='benefit-section__wrapper__points__text__subtitle'>
                Worth of online payments for bookings is being processed via our online booking software monthly.
              </div>
            </div>
          </div>
          <div className='benefit-section__wrapper__based-on'>Based on Trafft’s and Amelia’s users’ data.</div>
        </div>
      </ParallaxBanner>
    </ParallaxProvider>
  );
}

export default BenefitSection;